export default {"src":"/_next/static/media/0x56ee926bd8c72b2d5fa1af4d9e4cbb515a1e3adc.a00108f4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};